module.exports = __webpack_public_path__ + "img/work-s.d9c04a66.jpg";